import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronDown, User, Settings, LogOut } from 'lucide-react';
import { Button } from '../ui/button';
import { cn } from '../../lib/utils';
import { useAuth } from '../../providers/AuthProvider';
import { getUserDisplayName } from '@tco/shared-types';

export function UserDropdown() {
  const [isOpen, setIsOpen] = useState(false);
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  if (!user) return null;

  const handleLogout = async () => {
    try {
      await logout();
      setIsOpen(false);
      window.location.href = '/login';
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  const handleProfileClick = () => {
    setIsOpen(false);
    navigate('/profile');
  };

  const handleSettingsClick = () => {
    setIsOpen(false);
    navigate('/settings');
  };

  return (
    <div className="relative">
      <Button
        variant="ghost"
        className="flex items-center gap-2 px-3 py-2"
        onClick={() => setIsOpen(!isOpen)}
      >
        <div className="w-8 h-8 bg-primary rounded-full flex items-center justify-center">
          <span className="text-primary-foreground text-sm font-medium">
            {getUserDisplayName(user).split(' ').map(n => n[0]).join('').toUpperCase()}
          </span>
        </div>
        <div className="text-left hidden sm:block">
          <p className="text-sm font-medium text-foreground">{getUserDisplayName(user)}</p>
          <p className="text-xs text-muted-foreground">
            {user.role?.name || 'Пользователь'}
          </p>
        </div>
        <ChevronDown className={cn(
          "w-4 h-4 transition-transform",
          isOpen && "rotate-180"
        )} />
      </Button>

      {isOpen && (
        <>
          {/* Backdrop */}
          <div
            className="fixed inset-0 z-10"
            onClick={() => setIsOpen(false)}
          />

          {/* Dropdown */}
          <div className="absolute right-0 top-full mt-2 w-64 bg-card border border-border rounded-lg shadow-lg z-20">
            <div className="p-4 border-b border-border">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-primary rounded-full flex items-center justify-center">
                  <span className="text-primary-foreground font-medium">
                    {getUserDisplayName(user).split(' ').map(n => n[0]).join('').toUpperCase()}
                  </span>
                </div>
                <div>
                  <p className="font-medium text-foreground">{getUserDisplayName(user)}</p>
                  <p className="text-sm text-muted-foreground">{user.email}</p>
                  <p className="text-xs text-muted-foreground">
                    {user.role?.name || 'Пользователь'}
                  </p>
                </div>
              </div>
            </div>

            <div className="py-2">
              <button
                onClick={handleProfileClick}
                className="flex items-center gap-3 px-4 py-2 w-full text-left hover:bg-muted transition-colors"
              >
                <User className="w-4 h-4" />
                <span className="text-sm">Профиль</span>
              </button>
              <button
                onClick={handleSettingsClick}
                className="flex items-center gap-3 px-4 py-2 w-full text-left hover:bg-muted transition-colors"
              >
                <Settings className="w-4 h-4" />
                <span className="text-sm">Настройки</span>
              </button>
            </div>

            <div className="border-t border-border py-2">
              <button
                onClick={handleLogout}
                className="flex items-center gap-3 px-4 py-2 w-full text-left hover:bg-muted transition-colors text-destructive"
              >
                <LogOut className="w-4 h-4" />
                <span className="text-sm">Выйти</span>
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
}